"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.ErrorHandler = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const error_1 = __importDefault(require("@narf/error"));
const react_1 = require("react");
const alert_1 = __importStar(require("./components/alert"));
const notification_1 = __importDefault(require("./components/notification"));
const errors_1 = require("./types/errors");
Object.defineProperty(exports, "ErrorCode", { enumerable: true, get: function () { return errors_1.ErrorCode; } });
const errors_2 = require("./utils/errors");
const mixpanel_1 = require("./utils/mixpanel");
const defaultOnRouting = (url) => {
    window.location.href = url;
};
const defaultI18n = (key) => key;
const ErrorHandler = ({ open, onClose = () => null, error = {}, status, statusText, notificationContainer, isCartPage, onReload, onRouting = defaultOnRouting, onReAuth, track = () => null, i18n = defaultI18n, }) => {
    var _a, _b;
    const getCopy = isCartPage ? errors_2.getCartPageCopy : errors_2.getWidgetCopy;
    const errorDescription = (_a = error === null || error === void 0 ? void 0 : error.errorDescription) !== null && _a !== void 0 ? _a : error === null || error === void 0 ? void 0 : error.error_description;
    const errorCopy = getCopy(error, status);
    (0, react_1.useEffect)(() => {
        if (open)
            track(...(0, mixpanel_1.getErrorEvent)(error, statusText, status));
    }, [open]);
    const cartNotification = isCartPage ? ((0, jsx_runtime_1.jsx)(notification_1.default, { open, onClose, errorCode: error.error_code, container: notificationContainer, i18n, children: (_b = errorCopy.content) !== null && _b !== void 0 ? _b : errorDescription })) : ((0, jsx_runtime_1.jsx)(alert_1.default, Object.assign({ open: open, onClose: onClose, i18n: i18n, onAccept: onReload }, errorCopy, { children: errorDescription })));
    switch (status) {
        case provider_1.ResponseCode.CLIENT_ERROR:
            switch (error.error_code) {
                case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_CART_REOPEN_CAMPAIGNS:
                case errors_1.ErrorCode.INVALID_ITEM_ID:
                case errors_1.ErrorCode.INVALID_ITEM_QUANTITY:
                case errors_1.ErrorCode.CATALOG_ERROR:
                case errors_1.ErrorCode.CATALOG_ITEM_NOT_FOUND:
                case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_CAMPAIGNS:
                case errors_1.ErrorCode.CART_BRANDSPLACE_LIMITATION_EXCEEDED:
                    return ((0, jsx_runtime_1.jsx)(alert_1.default, Object.assign({ open: open, onClose: onClose, i18n: i18n }, errorCopy, { children: errorDescription })));
                case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_UNITS:
                case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_ITEM_UNITS:
                case errors_1.ErrorCode.RESERVATION_ERROR:
                case errors_1.ErrorCode.CART_MAX_UNIT_PER_MEMBER:
                    return cartNotification;
                default:
                    return (0, jsx_runtime_1.jsx)(alert_1.AlertDefault, { open, onClose, statusText, error, i18n });
            }
        case provider_1.ResponseCode.ACCESS_DENY:
            // TODO(fernando.cervera): simplify props interface
            return (0, jsx_runtime_1.jsx)(error_1.default, { open, onClose, onReAuth, onRouting, error, status, statusText, track });
        case provider_1.ResponseCode.INVALID_CART:
            switch (error.error_code) {
                case errors_1.ErrorCode.RESERVATION_NOT_ENOUGH_STOCK_ERROR:
                    return cartNotification;
                case errors_1.ErrorCode.CART_ITEM_RETRIEVAL_ERROR:
                case errors_1.ErrorCode.LOYALTY_RENEWAL:
                case errors_1.ErrorCode.CART_RULE_VBI_THIRD_PARTY:
                case errors_1.ErrorCode.CART_RULE_NON_VBI_THIRD_PARTY:
                case errors_1.ErrorCode.CART_RULE_FLASH_THIRD_PARTY:
                case errors_1.ErrorCode.RESERVATION_OVERFLOW_ERROR:
                case errors_1.ErrorCode.CART_NATURE:
                    return ((0, jsx_runtime_1.jsx)(alert_1.default, Object.assign({ open: open, onClose: onClose, i18n: i18n }, errorCopy, { children: errorDescription })));
                default:
                    return (0, jsx_runtime_1.jsx)(alert_1.AlertDefault, { open, onClose, statusText, error, i18n, onAccept: onReload });
            }
        case provider_1.ResponseCode.UNEXPECTED:
            if (error.error_code === errors_1.ErrorCode.CART_SAVE_ERROR)
                return ((0, jsx_runtime_1.jsx)(alert_1.default, Object.assign({ open: open, onClose: onClose, i18n: i18n, onAccept: onReload }, errorCopy, { children: errorDescription })));
            return (0, jsx_runtime_1.jsx)(alert_1.AlertDefault, { open, onClose, statusText, error, i18n, onAccept: onReload });
        default:
            return (0, jsx_runtime_1.jsx)(alert_1.AlertDefault, { open, onClose, statusText, error, i18n, onAccept: onReload });
    }
};
exports.ErrorHandler = ErrorHandler;
exports.default = exports.ErrorHandler;
